var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [
        {
            "name": "FollowInfo",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "uid",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "username",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "avatar",
                    "id": 3
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "gender",
                    "id": 4
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "signature",
                    "id": 5
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "grade",
                    "id": 6
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "location",
                    "id": 7
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "followType",
                    "id": 8
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "upliveCode",
                    "id": 9
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "officialAuth",
                    "id": 10
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "officialAuthContent",
                    "id": 11
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "qualityAuth",
                    "id": 12
                }
            ]
        },
        {
            "name": "Search",
            "fields": [],
            "messages": [
                {
                    "name": "User",
                    "fields": [],
                    "options": {
                        "objc_class_prefix": "SearchUser",
                        "java_package": "com.asiainno.uplive.proto"
                    },
                    "messages": [
                        {
                            "name": "Request",
                            "fields": [
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "content",
                                    "id": 1
                                },
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "page",
                                    "id": 2
                                },
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "pageSize",
                                    "id": 3
                                }
                            ]
                        },
                        {
                            "name": "Response",
                            "fields": [
                                {
                                    "rule": "repeated",
                                    "type": "FollowInfo",
                                    "name": "infos",
                                    "id": 1
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
}).build();

export default _root;


// WEBPACK FOOTER //
// ./js/header/searchuser/searchuser.pb.js